import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

/**
 * Animation for Team Intro Section - fade in with slide from left
 */
export const animateTeamIntro = (ref) => {
  if (ref.current) {
    const element = ref.current;
    const card = element.querySelector('[class*="section"]') || element;
    
    // Set initial state immediately to prevent flash
    if (card) {
      gsap.set(card, { opacity: 0, x: -80, scale: 0.95 });
    }
    
    const timer = setTimeout(() => {
      if (card) {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        });

        tl.to(card, {
          opacity: 1,
          x: 0,
          scale: 1,
          duration: 1.2,
          ease: "power3.out",
        });
        
        ScrollTrigger.refresh();
      }
    }, 100);
    
    return () => clearTimeout(timer);
  }
};

